import base from '@/__vue2stone/service/api/v1/__base';
import wsBase from '@/__vue2stone/service/wasaapi/v1/__base';
import i18n from '@/i18n';
import store from '@/store';
import moment from 'moment';
export default {
  async index(params) {
    return base.index({
      modelName: 'notification',
      params: params,
    });
  },
  async read(notificationId, data) {
    return wsBase.create({
      parentName: 'notification',
      parentId: notificationId,
      modelName: 'read',
      data: data,
    });
  },
  async readAll() {
    return wsBase.create({
      modelName: 'notification/readall',
    });
  },
  $_getNoticeTitle(notice) {
    if (!notice || !notice.data || !notice.data.type) return;
    if (notice.data.type === 'ActVersionCreated'
      || notice.data.type === 'LlCommentUpdated') {
      return `[${notice.data.factory_name || i18n.t('工廠名稱')}][${i18n.t(
        '法令更新',
      )}] ${notice.data.act_name || i18n.t('法規名稱')}`;
    } else if (notice.data.type === 'EventCreated') {
      if (notice.data.notified_type === 'member') {
        return `[${i18n.t('發生事件')}]${notice.data.event_type_name ||
          i18n.t('事件種類')}:${notice.data.event_name || i18n.t('事件主旨')}`;
      } else if (notice.data.notified_type === 'owner') {
        return `[${i18n.t('事件')}] ${notice.data.event_type_name ||
          i18n.t('事件種類')}: ${i18n.t(
          '您已被指定為本次風險事件的負責人',
        )}: [${notice.data.event_name || i18n.t('事件主旨')}]`;
      } else {
        return `[${i18n.t('事件')}] ${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'EventDeleted') {
      return `[${i18n.t('事件')}] [${notice.data.delete_user_name ||
        i18n.t('刪除者')}]${i18n.t('已刪除您建立的風險事件')}: [${notice.data
        .event_name || i18n.t('事件主旨')}]`;
    } else if (notice.data.type === 'EventUpdated') {
      if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('事件')}] [${notice.data.updated_user_name ||
          notice.data.editor_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您建立的風險事件內容')}: [${notice
          .data.event_name || i18n.t('事件主旨')}]`;
      } else if (notice.data.notified_type === 'owner') {
        return `[${i18n.t('事件')}] [${notice.data.updated_user_name ||
          notice.data.editor_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您負責的風險事件內容')}: [${notice
          .data.event_name || i18n.t('事件主旨')}]`;
      }
    } else if (notice.data.type === 'ChecklistRecordCreated') {
      return `[${i18n.t('點檢')}] [${notice.data.checklist_name ||
        i18n.t('填表人')}]${i18n.t('已提交[{name}]的點檢記錄,尚待您的覆核', {
        name: notice.data.checklist_name || i18n.t('點檢表'),
      })}`;
    } else if (notice.data.type === 'ChecklistUpdated') {
      if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('點檢')}] [${notice.data.updated_user_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您建立的點檢作業內容')}: [${notice
          .data.checklist_name || i18n.t('點檢表')}]`;
      } else if (notice.data.notified_type === 'checker') {
        return `[${i18n.t('點檢')}] [${notice.data.updated_user_name ||
          i18n.t('編輯者')}]${i18n.t(
          '已編輯您負責填表的點檢作業內容',
        )}: [${notice.data.checklist_name || i18n.t('點檢表')}]`;
      } else if (notice.data.notified_type === 'reviewer') {
        return `[${i18n.t('點檢')}] [${notice.data.updated_user_name ||
          i18n.t('編輯者')}]${i18n.t(
          '已編輯您負責覆核的點檢作業內容',
        )}: [${notice.data.checklist_name || i18n.t('點檢表')}]`;
      } else if (notice.data.notified_type === 'owner') {
        return `[${i18n.t('點檢')}] [${notice.data.updated_user_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您負責管理的點檢表內容')}: [${notice
          .data.checklist_name || i18n.t('點檢表')}]`;
      } else {
        return `[${i18n.t('點檢')}]${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'ChecklistDeleted') {
      return `[${i18n.t('點檢')}] [${notice.data.delete_user_name ||
        i18n.t('刪除者')}]已刪除點檢作業: [${notice.data.checklist_name ||
        i18n.t('點檢表')}]`;
    } else if (notice.data.type === 'ChecklistAssigned') {
      if (notice.data.notified_type === 'checker') {
        return `[${i18n.t('點檢')}] ${i18n.t(
          '您已被指定為一個點檢作業的填表人',
        )}: [${notice.data.checklist_name || i18n.t('點檢表')}]`;
      } else if (notice.data.notified_type === 'reviewer') {
        return `[${i18n.t('點檢')}] ${i18n.t(
          '您已被指定為一個點檢作業的覆核人',
        )}: [${notice.data.checklist_name || i18n.t('點檢表')}]`;
      } else if (notice.data.notified_type === 'owner') {
        return `[${i18n.t('點檢')}] ${i18n.t(
          '您已被指定為一個點檢表的管理者',
        )}: [${notice.data.checklist_name || i18n.t('點檢表')}]`;
      } else {
        return `[${i18n.t('點檢')}]${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'ChecklistTemplateVersionCreated') {
      return `[${i18n.t('更新點檢表公版')}]${i18n.t('已更新管理文件')}[${notice
        .data.checklist_name || i18n.t('點檢表名稱')}]${i18n.t(
        '的預設公版',
      )}[${notice.data.template_name || i18n.t('點檢表公版名稱')}]
      ${i18n.t('，點此查看更新後內容，請評估是否調整現有題目。')}`;
    } else if (notice.data.type === 'TaskCreated') {
      return `[${i18n.t('任務')}] ${i18n.t(
        '您已被指定為一個任務的負責人',
      )}:[${notice.data.task_name || i18n.t('任務主旨')}]`;
    } else if (notice.data.type === 'TaskUpdated') {
      if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('任務')}] [${notice.data.editor_name ||
          i18n.t('編輯者')}]已編輯您建立的任務內容: [${notice.data.task_name ||
          i18n.t('任務主旨')})]`;
      } else if (notice.data.notified_type === 'taker') {
        return `[${i18n.t('任務')}] [${notice.data.editor_name ||
          i18n.t('編輯者')}]已編輯您負責的任務內容: [
          ${notice.data.task_name || i18n.t('任務主旨')})]`;
      } else {
        return `[${i18n.t('任務')}]${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'SubTaskCreated') {
      return `[${i18n.t('待辦事項')}] ${i18n.t(
        '您有一個任務下的待辦事項',
      )}: [${notice.data.sub_task_name || i18n.t('待辦事項主旨')}]`;
    } else if (notice.data.type === 'SubTaskDone') {
      return `[${i18n.t('任務')}]${notice.data.taker_name ||
        '待辦執行人'}完成了${notice.data.sub_task_name ||
        '待辦事項主旨'}，快前往查看吧！`;
    } else if (notice.data.type === 'AuditRecordCreated') {
      return `[${i18n.t('稽核')}] ${i18n.t(
        '稽核作業已完成, 點此查看受稽結果並儘速回覆',
      )}: [${notice.data.audit_record_name || i18n.t('稽核表名稱')}]`;
    } else if (notice.data.type === 'AuditRecordReviewCreated') {
      return `[${i18n.t('稽核')}] [${notice.data.auditee ||
        i18n.t('受稽者')}]${i18n.t('已對稽核結果進行回覆, 點此查看')}: [${notice
        .data.audit_record_name || i18n.t('稽核表')}]`;
    } else if (notice.data.type === 'AuditRequestCreated') {
      if (notice.data.notified_type === 'auditor') {
        return `[${i18n.t('稽核')}] ${i18n.t(
          '您將於[{date}]進行一個新的稽核行程',
          {
            date: notice.data.record_at
              ? moment(notice.data.record_at).format('YYYY-MM-DD')
              : 'YYYY-MM-DD',
          },
        )}: [${notice.data.audit_request_name || i18n.t('稽核表名稱')}]`;
      } else if (notice.data.notified_type === 'auditee') {
        return `[${i18n.t('稽核')}] ${i18n.t(
          '您將於[{date}]進行一個新的受稽行程',
          {
            date: notice.data.record_at
              ? moment(notice.data.record_at).format('YYYY-MM-DD')
              : 'YYYY-MM-DD',
          },
        )}: [${notice.data.audit_request_name || i18n.t('稽核表名稱')}]`;
      } else {
        return `[${i18n.t('稽核')}] ${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'AuditRequestAuditeeRecord') {
      return `[${i18n.t('稽核提醒')}] ${i18n.t(
        '您今日有一個受稽行程',
      )}: [(${notice.data.audit_request_name || i18n.t('稽核表名稱')})]`;
    } else if (notice.data.type === 'AuditRequestAuditorRecord') {
      return `[${i18n.t('稽核提醒')}] ${i18n.t(
        '您今日有一個稽核行程',
      )}: [(${notice.data.audit_request_name || i18n.t('稽核表名稱')})]`;
    } else if (notice.data.type === 'AuditTemplateVersionCreated') {
      return `[${i18n.t('更新稽核表公版')}]${i18n.t('已更新管理文件')}[${notice
        .data.audit_name || i18n.t('稽核表名稱')}]${i18n.t(
        '的預設公版',
      )}[${notice.data.template_name || i18n.t('稽核表公版名稱')}]
      ${i18n.t('，點此查看更新後內容，請評估是否調整現有題目。')}`;
    } else if (notice.data.type === 'AlertCreated') {
      const level = notice.data.alert_level;
      let level_title = '';
      if (level && level === 1) {
        level_title = i18n.t('提醒');
      } else {
        level_title = i18n.t('警示');
      }
      let title =
        notice.data && notice.data.alert_name
          ? notice.data.alert_name
          : i18n.t('警示標題');
      return `[${level_title}]${title}, 請儘速前往查看並排除風險`;
    } else if (notice.data.type === 'LicenseRemindDateExpired') {
      if (notice.data.notified_type === 'taker') {
        return `[${i18n.t('證照續辦提醒')}] ${i18n.t(
          '您所持證照應行續辦',
        )}: [${notice.data.license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'reminder') {
        return `[${i18n.t('證照續辦提醒')}] ${i18n.t(
          '[{name}]所持證照應行續辦',
          {
            name:
              notice.data.taker_name ||
              notice.data.factory_name ||
              i18n.t('人員名稱'),
          },
        )}: [${notice.data.license_name || i18n.t('證照名稱')}]`;
      }
    } else if (notice.data.type === 'LicenseStatitoryExtensionExpired') {
      if (notice.data.notified_type === 'taker') {
        return `[${i18n.t('證照展延期限屆至')}] ${i18n.t(
          '您所持證照的法定展延期限屆至',
        )}: [${notice.data.license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'reminder') {
        return `[${i18n.t('證照展延期限屆至')}] ${i18n.t(
          '[{name}]所持證照的法定展延期限屆至',
          {
            name:
              notice.data.taker_name ||
              notice.data.factory_name ||
              i18n.t('人員名稱'),
          },
        )}: [${notice.data.license_name || i18n.t('證照名稱')}]`;
      }
    } else if (notice.data.type === 'LicenseValidEndDateExpired') {
      if (notice.data.notified_type === 'taker') {
        return `[${i18n.t('證照逾期通知')}] 您所持證照的有效期限屆至: [${notice
          .data.license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'reminder') {
        return `[${i18n.t('證照逾期通知')}] [${notice.data.taler_name ||
          notice.data.factory_name ||
          i18n.t('人員名稱')}]${i18n.t('所持證照的有效期限屆至')}: [${notice
          .data.license_name || i18n.t('證照名稱')}]`;
      }
    } else if (notice.data.type === 'LicenseCreated') {
      if (notice.data.notified_type === 'taker') {
        return `[${i18n.t('證照')}] ${i18n.t(
          '已新增一則您持有的證照資訊',
        )}: [${notice.data.license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'reminder') {
        return `[${i18n.t('證照')}] ${i18n.t(
          '已新增一則您管理的證照資訊',
        )}: [${notice.data.license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'agent') {
        return `[${i18n.t('證照')}] ${i18n.t(
          '已新增一則您作為代理人的報准人員證照資訊',
        )}: [${notice.data.license_name || i18n.t('證照名稱')}]`;
      } else {
        return `[${i18n.t('證照')}]${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'LicenseRenewed') {
      if (notice.data.notified_type === 'taker') {
        return `[${i18n.t('證照')}] [${notice.data.editor_name ||
          i18n.t('更新者')}]已更新您持有的證照資訊: [${notice.data
          .license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'reminder') {
        return `[${i18n.t('證照')}] [${notice.data.editor_name ||
          i18n.t('更新者')}]已更新您管理的證照資訊: [${notice.data
          .license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'agent') {
        return `[${i18n.t('證照')}] [${notice.data.editor_name ||
          i18n.t('更新者')}]已更新您作為代理人的報准人員證照資訊: [${notice.data
          .license_name || i18n.t('證照名稱')}]`;
      } else {
        return `[${i18n.t('證照')}]${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'LicenseUpdated') {
      if (notice.data.notified_type === 'taker') {
        return `[${i18n.t('證照')}] [${notice.data.editor_name ||
          i18n.t('編輯者')}]已編輯您持有的證照資訊: [${notice.data
          .license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'reminder') {
        return `[${i18n.t('證照')}] [${notice.data.editor_name ||
          i18n.t('編輯者')}]已編輯您管理的證照資訊: [${notice.data
          .license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'agent') {
        return `[${i18n.t('證照')}] [${notice.data.editor_name ||
          i18n.t('編輯者')}]已編輯您作為代理人的報准人員證照資訊: [${notice.data
          .license_name || i18n.t('證照名稱')}]`;
      } else {
        return `[${i18n.t('證照')}]${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'LicenseTemplateVersionCreated') {
      return `[${i18n.t('更新證照公版')}]${i18n.t('已更新管理文件')}[${notice
        .data.license_name || i18n.t('證照名稱')}]${i18n.t(
        '的預設公版',
      )}[${notice.data.template_name || i18n.t('證照公版名稱')}]${i18n.t(
        '，點此查看更新後內容。',
      )}`;
    } else if (notice.data.type === 'LicenseRetrainRemind') {
      if (notice.data.notified_type === 'taker') {
        return `[${i18n.t('證照回訓提醒')}] ${i18n.t(
          '您所持證照應行回訓',
        )}: [${notice.data.license_name || i18n.t('證照名稱')}]`;
      } else if (notice.data.notified_type === 'reminder') {
        return `[${i18n.t('證照回訓提醒')}] ${i18n.t(
          '[{name}]所持證照應行回訓',
          {
            name:
              notice.data.taker_name ||
              notice.data.factory_name ||
              i18n.t('人員名稱'),
          },
        )}: [${notice.data.license_name || i18n.t('證照名稱')}]`;
      }
    } else if (notice.data.type === 'ChangeRemindEvaluatorExpired') {
      return `[${i18n.t('變動計畫評估到期通知')}] ${i18n.t(
        '{item_name}將於今日到期，請盡快前往變動風險評估',
        {
          item_name: notice.data.change_name || i18n.t('計劃名稱'),
        },
      )}`;
    } else if (notice.data.type === 'ChangeRemindOwnerExpired') {
      return `[${i18n.t('變動計畫評估到期通知')}] ${i18n.t(
        '{item_name}將於今日到期，請盡快提醒尚未評估的評估人員前往變動風險評估',
        {
          item_name: notice.data.change_name || i18n.t('計劃名稱'),
        },
      )}`;
    } else if (notice.data.type === 'ChangeVersionCreated') {
      if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('變動計畫')}] [${notice.data.update_user_name ||
          i18n.t('更新者')}]${i18n.t('已更新您建立的變動計畫內容')}: [${notice
          .data.change_name || i18n.t('計畫名稱')}]`;
      } else if (notice.data.notified_type === 'owner-original') {
        return `[${i18n.t('變動計畫')}] [${notice.data.update_user_name ||
          i18n.t('更新者')}]${i18n.t('已更新您建立的變動計畫內容')}: [${notice
          .data.change_name || i18n.t('計畫名稱')}]`;
      } else if (notice.data.notified_type === 'owner-new') {
        return `[${i18n.t('變動計畫')}] ${i18n.t(
          '您已被指定為一項變動計畫的負責人, 點此查看',
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      }
    } else if (notice.data.type === 'ChangeStopped') {
      if (notice.data.notified_type === 'evaluator') {
        return `[${i18n.t('變動計畫')}] ${i18n.t(
          '[{name}]已中止您參與評估的變動計畫',
          {
            name: notice.data.stop_user_name || i18n.t('中止者'),
          },
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      } else if (notice.data.notified_type === 'owner') {
        return `[${i18n.t('變動計畫')}] ${i18n.t(
          '[{name}]已中止您負責的變動計畫',
          {
            name: notice.data.stop_user_name || i18n.t('中止者'),
          },
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      } else if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('變動計畫')}] ${i18n.t(
          '[{name}]已中止您建立的變動計畫',
          {
            name: notice.data.stop_user_name || i18n.t('中止者'),
          },
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      }
    } else if (notice.data.type === 'ChangeRestarted') {
      if (notice.data.notified_type === 'evaluator') {
        return `[${i18n.t('變動計畫')}] ${i18n.t(
          '[{name}]已重啟您參與評估的變動計畫',
          {
            name: notice.data.restart_user_name || i18n.t('重啟者'),
          },
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      } else if (notice.data.notified_type === 'owner') {
        return `[${i18n.t('變動計畫')}] ${i18n.t(
          '[{name}]已重啟您負責的變動計畫',
          {
            name: notice.data.restart_user_name || i18n.t('重啟者'),
          },
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      } else if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('變動計畫')}] ${i18n.t(
          '[{name}]已重啟您建立的變動計畫',
          {
            name: notice.data.restart_user_name || i18n.t('重啟者'),
          },
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      }
    } else if (notice.data.type === 'ChangeAssignmentCreated') {
      return `[${i18n.t('變動計畫')}] ${i18n.t(
        '您已被指定為一項變動計畫的領域評估人員, 請儘速處理',
      )} :[${notice.data.change_name || i18n.t('計畫名稱')}]`;
    } else if (notice.data.type === 'ChangeCreated') {
      return `[${i18n.t('變動計畫')}] ${i18n.t(
        '您已被指定為一項變動計畫的負責人, 點此查看',
      )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
    } else if (notice.data.type === 'ChangeUpdated') {
      if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('變動計畫')}] [${notice.data.update_user_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您建立的變動計畫內容')}: [${notice
          .data.change_name || i18n.t('計畫名稱')}]`;
      } else if (notice.data.notified_type === 'owner-original') {
        return `[${i18n.t('變動計畫')}] [${notice.data.update_user_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您負責的變動計畫內容')}: [${notice
          .data.change_name || i18n.t('計畫名稱')}]`;
      } else if (notice.data.notified_type === 'owner-new') {
        return `[${i18n.t('變動計畫')}] ${i18n.t(
          '您已被指定為一項變動計畫的負責人, 點此查看',
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      }
    } else if (notice.data.type === 'ChangeStarted') {
      return `[${i18n.t('變動計畫')}] [${notice.data.start_user_name ||
        i18n.t('計畫負責人名稱')}]${i18n.t(
        '已正式啟動您建立的變動計畫',
      )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
    } else if (notice.data.type === 'ChangeAssignmentUpdated') {
      if (notice.data.notified_type === 'original') {
        return `[${i18n.t('變動計畫')}] [${notice.data.update_user_name ||
          i18n.t('編輯者')}]${i18n.t(
          '已編輯您參與評估的變動計畫內容',
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      } else if (notice.data.notified_type === 'new') {
        return `[${i18n.t('變動計畫')}] [${notice.data.update_user_name ||
          i18n.t('編輯者')}]${i18n.t(
          '您已被指定為一項變動計畫的領域評估人員, 請儘速處理',
        )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
      }
    } else if (notice.data.type === 'ChangeDeleted') {
      return `[${i18n.t('變動計畫')}] ${i18n.t(
        '[{name}]已刪除您建立的變動計畫',
        {
          name: notice.data.delete_user_name || i18n.t('刪除者'),
        },
      )}: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
    } else if (notice.data.type === 'ContractorEnterRecordRemindCreated') {
      if (notice.data.notified_type === 'member') {
        return `[${i18n.t('進廠')}] ${(i18n.t('今日有外部廠商[{name}]進廠作業'),
        {
          name: notice.data.contractor_name || i18n.t('進廠承攬商名稱'),
        })}: [${notice.data.task_content || i18n.t('進廠主旨')}]`;
      } else if (notice.data.notified_type === 'owner') {
        return `[${i18n.t('進廠提醒')}] 您為今日外部廠商[${notice.data
          .contractor_name ||
          i18n.t(
            '進廠承攬商名稱',
          )}]進廠作業的記錄負責人, 請於廠商收工後進行檢查: [${notice.data
          .task_content || i18n.t('進廠主旨')}]`;
      } else {
        return `[${i18n.t('進廠')}] ${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'ContractorEnterRecordCreated') {
      return `[${i18n.t('進廠')}] ${i18n.t(
        '您已被指定為一個進廠記錄的負責人',
      )}: [${notice.data.task_content || i18n.t('進廠主旨')}]`;
    } else if (notice.data.type === 'ContractorEnterRecordUpdated') {
      if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('進廠')}] [${notice.data.updated_user_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您建立的進廠記錄表內容')}: [${notice
          .data.task_content || i18n.t('進廠主旨')}]`;
      } else if (notice.data.notified_type === 'owner') {
        return `[${i18n.t('進廠')}] [${notice.data.updated_user_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您負責的進廠記錄表內容')}: [${notice
          .data.task_content || i18n.t('進廠主旨')}]`;
      } else {
        return `[${i18n.t('進廠')}] ${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'ContractorEnterRecordDeleted') {
      return `[${i18n.t('進廠')}] [${notice.data.delete_user_name ||
        i18n.t('刪除者')}]${i18n.t('已刪除您建立的進廠記錄表')}: [${
        notice.data.task_content
      }]`;
    } else if (notice.data.type === 'LlBroadcastCreated') {
      if (notice.data.factory_name) {
        return ` [${notice.data.factory_name || i18n.t('工廠名稱')}][${i18n.t(
          'ESGoal快報',
        )}] ${notice.data.ll_broadcast_name || i18n.t('快報主旨')}`;
      } else {
        return ` [${notice.data.organization_name ||
          i18n.t('集團名稱')}][${i18n.t('ESGoal快報')}] ${notice.data
          .ll_broadcast_name || i18n.t('快報主旨')}`;
      }
    } else if (notice.data.type === 'InternalTrainingCreated') {
      return `[${i18n.t('教育訓練')}] ${i18n.t(
        '您已被指定為一項教育訓練的負責人',
      )}: [${notice.data.training_name || i18n.t('教育訓練名稱')}]`;
    } else if (notice.data.type === 'InternalTrainingRemind') {
      return `[${i18n.t('教育訓練提醒')}] ${i18n.t(
        '今日將進行一項由您負責的教育訓練, 請記得填寫教育訓練記錄',
      )}: [${notice.data.training_name || i18n.t('教育訓練名稱')}]`;
    } else if (notice.data.type === 'InternalTrainingUpdated') {
      if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('教育訓練')}] [${notice.data.updated_user_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您建立的教育訓練內容')}: [${notice
          .data.training_name || i18n.t('教育訓練名稱')}]`;
      } else if (notice.data.notified_type === 'principal') {
        return `[${i18n.t('教育訓練')}] [${notice.data.updated_user_name ||
          i18n.t('編輯者')}]${i18n.t('已編輯您負責的教育訓練內容')}: [${notice
          .data.training_name || i18n.t('教育訓練名稱')}]`;
      } else {
        return `[${i18n.t('教育訓練')}] ${i18n.t('一則通知')}`;
      }
    } else if (notice.data.type === 'InternalTrainingDeleted') {
      return `[${i18n.t('教育訓練')}] ${i18n.t(
        '[{name}]已刪除您建立的教育訓練',
        {
          name: notice.data.delete_user_name || i18n.t('刪除者'),
        },
      )}: [${notice.data.training_name || i18n.t('教育訓練名稱')}]`;
    } else if (notice.data.type === 'InternalTrainingTemplateVersionCreated') {
      return `[${i18n.t('更新教育訓練公版')}]${i18n.t(
        '已更新管理文件',
      )}[${notice.data.internal_training_name ||
        i18n.t('教育訓練名稱')}]${i18n.t('的預設公版')}[${notice.data
        .template_name || i18n.t('教育訓練公版名稱')}]${i18n.t(
        '，點此查看更新後內容。',
      )}`;
    } else if (notice.data.type === 'SubTaskUndoRemind') {
      return `[${i18n.t('待辦事項提醒')}] ${i18n.t(
        '您的待辦事項期限屆至, 請儘速處理',
      )}: [${notice.data.sub_task_name || i18n.t('待辦事項主旨')}]`;
    } else if (notice.data.type === 'TaskUndoRemind') {
      return `[${i18n.t('任務提醒')}] ${i18n.t(
        '您所負責任務[{task}]中有待辦事項期限屆至, 已通知負責人員[{name}]儘速處理',
        {
          task: notice.data.task_name || i18n.t('任務主旨'),
          name: notice.data.sub_task_taker_name || i18n.t('待辦執行人'),
        },
      )}: [${notice.data.sub_task_name || i18n.t('待辦事項主旨')}]`;
    } else if (notice.data.type === 'TaskUnCheckRemind') {
      if (notice.data.notified_type === 'taker') {
        return `[${i18n.t('任務提醒')}] ${i18n.t(
          '您所負責任務的到期日屆至, 請儘速處理',
        )}: [${notice.data.task_name || i18n.t('任務主旨')}]`;
      } else if (notice.data.notified_type === 'creator') {
        return `[${i18n.t('任務提醒')}] ${i18n.t(
          '您所建立任務的到期日屆至, 但負責人尚未完成審核',
        )}: [${notice.data.task_name || i18n.t('任務主旨')}]`;
      }
    } else if (notice.data.type === 'ContractorEnterRecordNotifyAtRemind') {
      let _enterStartDate = 'YYYY-MM-DD';
      if (notice.data.enter_start_date) {
        _enterStartDate = moment(notice.data.enter_start_date).format(
          'YYYY-MM-DD',
        );
      }
      let _enterStartTime = ""
      if (notice.data.enter_start_time) {
        _enterStartTime = moment(notice.data.enter_start_time).format(
          'HH:MM',
        );
      }
      return `[${i18n.t('進廠')}-${i18n.t('自設提醒事項')}] ${i18n.t(
        '外部廠商',
      )}[${notice.data.contractor_name ||
        i18n.t(
          '進廠承攬商名稱',
        )}]於[${_enterStartDate}][${_enterStartTime}]進廠作業，請確認自設提醒事項。`;
    } else if (notice.data.type === 'ContractorLicenseTemplateVersionCreated') {
      return `[${i18n.t('更新承攬商資格證公版')}] ${i18n.t(
        '已更新管理文件',
      )}[${notice.data.contractor_license_name ||
        i18n.t('承攬商資格證名稱')}]${i18n.t('的預設公版')}[${notice.data
        .template_name || i18n.t('承攬商資格證公版名稱')}]${i18n.t(
        '，點此查看更新後內容。',
      )}`;
    } else if (notice.data.type === 'ChangeAssignmentRenew') {
      return `[${i18n.t('變動計畫')}][${notice.data.update_user_name ||
        i18n.t('更新者')}]${i18n.t('已更新您參與評估的變動計畫內容')}:[${notice
        .data.change_name || i18n.t('計畫名稱')}]`;
    } else if (notice.data.type === 'ChangeCompleted') {
      return `[${i18n.t('變動計畫提醒')}]您所負責變動計畫的評估已完成:[${notice
        .data.change_name || i18n.t('計畫名稱')}]`;
    } else if (notice.data.type === 'ChangeRecordAnswerUpdated') {
      return `[${i18n.t('變動計畫')}][${notice.data.evaluator_name}]已更新[${
        notice.data.change_record_answer_name
      }]評估結果,點此查看: [${notice.data.change_name || i18n.t('計畫名稱')}]`;
    } else if (notice.data.type === 'ChecklistAssignmentUndoNotify') {
      return `[${i18n.t('點檢提醒')}] 您有尚未完成的點檢作業, 請儘速處理: [${notice.data.checklist_name || i18n.t('點檢表')}]`;
    } else if (notice.data.type === 'ChecklistAssignmentNotify') {
      return `[${i18n.t('點檢')}] 您今日的點檢作業: [${notice.data.checklist_name || i18n.t('點檢表')}]`;
    } else if (notice.data.type === 'ChecklistScheduleCreatedNotify') {
      return `[${i18n.t('點檢')}] 您已被指定為一個點檢作業的填表人: [${notice.data.checklist_name || i18n.t('點檢表')}]`;
    } else if (notice.type === 'ChecklistSampleCreated') {
      const {record_type: recordType, score,created_user_name: creator,checklist_record_name: checklistName} = notice.data;
      const subText = recordType === 'reviewers'
        ? '曾覆核'
        : recordType === 'samples'
        ? '曾抽檢'
        : '';
      return score === 10
        ? `[${i18n.t('點檢')}] [${creator || i18n.t('抽檢者')}] 已抽檢您${subText}的點檢作業 [${checklistName || i18n.t('點檢表名稱')}] ，抽檢結果為 通過`
        : score === 5
        ? `[${i18n.t('點檢')}] [${creator || i18n.t('抽檢者')}] 已抽檢您${subText}的點檢作業 [${checklistName || i18n.t('點檢表名稱')}] ，抽檢結果為 未通過，請儘速查看抽檢評價`
        : i18n.t('一則通知');
    } else {
      return i18n.t('一則通知');
    }
  },
  $_getRoutePath(notice) {
    let factoryId = notice.factory_id || store.state.app.factoryId;
    if (notice.type === 'ActVersionCreated' || notice.type === 'LlCommentUpdated') {
      return `/factory/${factoryId}/act-content-main/${notice.id}`;
    } else if (
      notice.type === 'EventCreated' ||
      notice.type === 'EventUpdated' ||
      notice.type === 'EventDeleted'
    ) {
      return `/factory/${factoryId}/event-content/${notice.id}`;
    } else if (notice.type === 'ChecklistUpdated') {
      return `/factory/${factoryId}/checklist-content/${notice.checklist_id || notice.id}`;
    } else if (notice.type === 'ChecklistRecordCreated') {
      return `/factory/${factoryId}/checklist-result-view/${notice.id}`;
    } else if (notice.type === 'TaskCreated' || notice.type === 'TaskUpdated') {
      return `/factory/${factoryId}/task-content/${notice.id}`;
    } else if (
      notice.type === 'SubTaskCreated' ||
      notice.type === 'SubTaskDone' ||
      notice.type === 'SubTaskUndoRemind' ||
      notice.type === 'TaskUndoRemind' ||
      notice.type === 'TaskUnCheckRemind'
    ) {
      return `/factory/${factoryId}/task-content/${notice.task_id || notice.id}`;
    } else if (notice.type === 'AuditRecordCreated') {
      return `/factory/${factoryId}/auditee-reply-content/${notice.id}`;
    } else if (notice.type === 'AuditRecordReviewCreated') {
      return `/factory/${factoryId}/auditer-result/${notice.id}`;
    } else if (notice.type === 'AuditRequestCreated') {
      return `/factory/${factoryId}/audit-question-content/${notice.audit_id || notice.id}`;
    } else if (notice.type === 'AuditTemplateVersionCreated') {
      return `/factory/${factoryId}/audit-content/${notice.audit_id || notice.id}`;
    } else if (
      notice.type === 'AuditRequestAuditeeRecord' ||
      notice.type === 'AuditRequestAuditorRecord'
    ) {
      return `/factory/${factoryId}/audit-assignment/${notice.id}`;
    } else if (notice.type === 'AlertCreated') {
      return `/factory/${factoryId}/alert-content/${notice.alert_id || notice.id}`;
    } else if (notice.type === 'ChecklistDeleted') {
      return `/factory/${factoryId}/checklist-content/${notice.checklist_id || notice.id}`;
    } else if (notice.type === 'ChecklistTemplateVersionCreated') {
      return `/factory/${factoryId}/checklist-content/${notice.checklist_id || notice.id}`;
    } else if (notice.type === 'ChecklistAssigned') {
      if (notice.notified_type === 'reviewer') {
        return `/factory/${factoryId}/checklist-content/${notice.checklist_id || notice.id}`;
      } else if (notice.notified_type === 'checker') {
        return `/factory/${factoryId}/checklist-assignment-main/${notice.checklist_id || notice.id}`;
      } else if (notice.notified_type === 'owner') {
        return `/factory/${factoryId}/checklist-content/${notice.checklist_id || notice.id}`;
      }
    } else if (
      notice.type === 'ChangeRemindEvaluatorExpired' ||
      notice.type === 'ChangeCreated' ||
      notice.type === 'ChangeUpdated' ||
      notice.type === 'ChangeAssignmentCreated' ||
      notice.type === 'ChangeDeleted' ||
      notice.type === 'ChangeAssignmentUpdated' ||
      notice.type === 'ChangeAssignmentRenew'
    ) {
      const path = `/factory/${factoryId}/change-assignment-main/${notice.change_id || notice.id}`;
      const subclassId = (notice.factory_system_subclass || notice.system_subclass)?.id;
      return subclassId ? `${path}?subclass=${subclassId}` : path;
    } else if (
      notice.type === 'ContractorEnterRecordRemindCreated' ||
      notice.type === 'ContractorEnterRecordCreated' ||
      notice.type === 'ContractorEnterRecordUpdated' ||
      notice.type === 'ContractorEnterRecordDeleted'
    ) {
      return `/factory/${factoryId}/contractor-operation-content/${notice.id}`;
    } else if (notice.type === 'ContractorEnterRecordNotifyAtRemind') {
      return `/factory/${factoryId}/contractor-operation-content/${notice.contractor_enter_record_id || notice.id}`;
    } else if (notice.type === 'ContractorLicenseTemplateVersionCreated') {
      return `/factory/${factoryId}/contractor/${notice.contractor_id}/contractor-license-content/${notice.contractor_license_id || notice.id}`;
    } else if (
      notice.type === 'ChangeRemindOwnerExpired' ||
      notice.type === 'ChangeRestarted' ||
      notice.type === 'ChangeStopped' ||
      notice.type === 'ChangeStarted' ||
      notice.type === 'ChangeCompleted' ||
      notice.type === 'ChangeVersionCreated' ||
      notice.type === 'ChangeRecordAnswerUpdated'
    ) {
      return `/factory/${factoryId}/change-content/${notice.change_id || notice.id}`;
    } else if (notice.type === 'LlBroadcastCreated') {
      if (notice.organization_id) {
        return `/organization/${notice.organization_id}/broadcast-content/${notice.ll_broadcast_id}`;
      } else {
        return `/factory/${factoryId}/broadcast-content/${notice.ll_broadcast_id}`;
      }
    } else if (
      notice.type === 'LicenseUpdated' ||
      notice.type === 'LicenseCreated' ||
      notice.type === 'LicenseRenewed' ||
      notice.type === 'LicenseRemindDateExpired' ||
      notice.type === 'LicenseValidEndDateExpired' ||
      notice.type === 'LicenseStatitoryExtensionExpired'
    ) {
      return `/factory/${factoryId}/license-content-main/${notice.id}`;
    } else if (notice.type === 'LicenseTemplateVersionCreated') {
      return `/factory/${factoryId}/license-content-main/${notice.license_id || notice.id}`;
    } else if (
      notice.type === 'InternalTrainingCreated' ||
      notice.type === 'InternalTrainingUpdated' ||
      notice.type === 'InternalTrainingDeleted'
    ) {
      return `/factory/${factoryId}/internal-training-content/${notice.training_id || notice.id}`;
    } else if (notice.type === 'InternalTrainingTemplateVersionCreated') {
      return `/factory/${factoryId}/internal-training-content/${notice.internal_training_id || notice.id}`;
    } else if (
      notice.type === 'ChecklistAssignmentUndoNotify' ||
      notice.type === 'ChecklistAssignmentNotify'
    ) {
      return `/factory/${factoryId}/checklist-assignment-main/${notice.checklist_assignment_id || notice.id}`
    } else if (notice.type === 'ChecklistSampleCreated') {
      return `/factory/${factoryId}/checklist-result-view/${notice.checklist_record_id || notice.id}`;
    } else if (notice.type === 'ChecklistScheduleCreatedNotify') {
      return `/factory/${factoryId}/checklist/${notice.checklist_id}/checklist-schedule-content/${notice.general_schedule_setting_id}?title=${notice.checklist_name}&checklistVersionId=${notice.checklist_version_id}`
    } else {
      return '';
    }
  },
  $_getNotificationClickName(notice) {
    //取得通知點擊名稱->用來判斷是否有該權限
    if (notice.type === 'ChecklistRecordCreated') {
      return 'review-result';
    } else if (notice.type === 'AlertCreated') {
      return 'alert-read';
    } else {
      return '';
    }
  },
};
